/*
 * @Author: 陈朝晖
 * @Date: 2022-04-11 17:34:30
 * @LastEditTime: 2022-12-12 14:28:47
 * @Description:
 */
import axios from 'axios';
import getSign from '@daze/sign';
let base;

if (process.env.NODE_ENV === 'development') {
    base = 'https://test-api.fjdaze.com/';
    // base = "https://api.fjdaze.com/";
    // base = "http://192.168.0.17:8012/";
} else if (window.dazeRunningConfing && window.dazeRunningConfing.DAZE_APPLICATION_RUNNING_TIME === 'development') {
    // 壳在测试环境 全局挂载上没有找到的话 一概把处理交出去 下面的代码也应该逐步交出去到课上处理这个running time
    base = 'https://test-api.fjdaze.com/';
} else if (location.host.indexOf('127.0.0.1') !== -1) {
    base = 'https://test-api.fjdaze.com/';
} else if (location.host.indexOf('192.168.0') !== -1) {
    base = 'https://test-api.fjdaze.com/';
} else if (location.host.indexOf('test.fjdaze.com') > -1) {
    base = 'https://test-api.fjdaze.com/';
} else if (location.host.indexOf('localhost') === 0) {
    base = 'https://test-api.fjdaze.com/';
} else {
    base = 'https://api.fjdaze.com/';
}
const ajax = axios.create({
    baseURL: base,
    timeout: 60000,
});

const cancelToken = axios.CancelToken;
// 添加请求拦截器
ajax.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        const tokenName = window.dazeRunningConfing
            ? window.dazeRunningConfing.DAZE_APPLICATION_TOKEN_NAME || 'accessToken'
            : 'accessToken';
        const token = localStorage.getItem(tokenName);
        if (token) {
            config.headers.common['AccessToken'] = token;
        }
        // eslint-disable-next-line new-cap
        config.cancelToken = new cancelToken((c) => {
            // 回调回去取消方法
            if (config.params) {
                config.params.abort && config.params.abort(c);
            } else if (config.abort) {
                config.abort(c);
            }
        });
        if (config.params && config.params.abort) {
            delete config.params.abort;
        } else if (config.abort) {
            delete config.abort;
        }

        let data;
        if (config.method === 'get') {
            data = config.params;
        } else {
            data = config.data;
        }
        // 验签加密
        let sign = getSign(data);
        config.headers = {
            ...config.headers,
            ...sign,
        };
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
ajax.interceptors.response.use(
    function (res) {
        // 对响应数据做点什么
        return res.data;
    },
    function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

const install = function (Vue) {
    Vue.prototype.$ajax = ajax;
};

const ajax2 = axios.create({
    baseURL: base,
    timeout: 60000,
});

ajax2.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        let data;
        if (config.method === 'get') {
            data = config.params;
        } else {
            data = config.data;
        }

        // 验签加密
        let sign = getSign(data);
        config.headers = {
            ...config.headers,
            ...sign,
        };
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

export default {
    install,
    ajax,
    ajax2,
    // eslint-disable-next-line eol-last
};
